<template>
  <v-col
    :cols="12"
    style="position: relative;"
    @mouseenter="handleMouseEnter"
    @click.stop="note.type != 'card' ? $emit('clearDragSelection') : null"
    :class="{
      'lighten-4 blue': dragSelected
    }"
    class="noteBlock py-0 px-0 mb-0"
  >
    <!-- <v-skeleton-loader
      v-if="slowLoad && !renderBlock"
      type="text"
      class="pl-10"
      max-width="500"
      max-height="70"
    ></v-skeleton-loader> -->
    <v-card
      v-if="promptToAdd.show"
      class="elevation-1 white px-1"
      style=" position: absolute; top: 25px; z-index: 1;"
    >
      <v-row no-gutters>
        <v-col class="pa-0 strong" style="place-self: center;">Capture Webpage?</v-col>
        <v-col class="shrink pa-0">
          <v-btn v-if="!promptToAdd.adding" icon @click="captureWebpage(promptToAdd.value)">
            <v-icon color="primary">check_circle</v-icon>
          </v-btn>
          <v-progress-linear v-if="promptToAdd.adding" indeterminate></v-progress-linear>
        </v-col>
        <v-col class="shrink pa-0">
          <v-btn icon @click="promptToAdd = { show: false, value: '', adding: false }">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <!-- <div v-if="dragSelectedFirst" :style="`position: absolute; left: 50%; top: -10px; z-index: 2`">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-fade-transition>
            <v-btn
              outlined
              icon
              class="orange lighten-2"
              color="grey darken-1"
              small
              elevation="0"
              @mouseenter="on.mouseenter"
              @mouseleave="on.mouseleave"
              @click=""
            >
              <v-icon small>add_to_photos</v-icon>
            </v-btn>
          </v-fade-transition>
        </template>
        <span>Group</span>
        <shortcut-icon size="12" :keys="['Ctrl', 'Enter']"></shortcut-icon>
      </v-tooltip>
    </div> -->
    <!-- <template v-if="inlinePreview && inlinePreview.show">
      <v-menu
        v-model="inlinePreview.show"
        :close-on-content-click="false"
        absolute
        :attach="$el"
        :position-y="inlinePreview.y"
        :position-x="inlinePreview.x"
        :nudge-top="100"
      >
        <resource-details-card
          :resource="resources[inlinePreview.resourceId]"
          showOpen
          @close="inlinePreview.show = false"
        ></resource-details-card>
      </v-menu>
    </template> -->
    <!-- <resource-card
      v-if="note.type == 'widget'"
      :blockData="{
        resource: widgetResource,
        excerpts: excerpts,
        showSource: note.showSource
      }"
      :class="`handle-${note.id}`"
      ref="widget"
      tabindex="0"
      blockType="note"
      @mouseenter="hovering = true"
      @mouseleave="hovering = false"
      @keyUp="$emit('traverseBlocks', { toIndex: index - 1, event: $event })"
      @keyDown="$emit('traverseBlocks', { toIndex: index + 1, event: $event })"
      @keyEnter="userCanEdit ? $emit('addNewLine', { order: note.order + 1 }) : null"
      @delete="userCanEdit ? $emit('removeNoteBlock', { noteId: note.id }) : null"
      @clicked="showPreview = true"
      @rendered="$emit('rendered')"
      @doubleClick="
        showPreview = false;
        setResourceViewer({ show: true, resourceId: widgetResource.id, width: 50 });
      "
      color="transparent"
    >
      <template v-slot="props" name="after">
        <div :style="`position: absolute; right: 10px;`" v-if="props.hover || showPreview">
          <v-menu v-model="showPreview" :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on">
                <v-icon>more_horiz</v-icon>
              </v-btn>
            </template>
            <resource-details-card
              :resource="widgetResource"
              showOpen
              @close="showPreview = false"
            ></resource-details-card>
          </v-menu>
        </div>
      </template>
    </resource-card> -->
    <!-- <note-card-embed
      v-if="note.noteCardId"
      ref="embeddedCard"
      :noteCardId="note.noteCardId"
      :parentNoteId="note.id"
      @traverseLeaveDown="
        $emit('traverseBlocks', { toIndex: index + 1, event: $event, direction: 'down' })
      "
      @traverseLeaveUp="$emit('traverseBlocks', { toIndex: index - 1, event: $event })"
      @delete="$emit('removeCard', $event)"
      @moveOrder="$emit('moveOrder', { amount: $event })"
      @indentCard="
        log('indent');
        $emit('indentCard', $event);
      "
      @deIndentCard="$emit('deIndentCard', $event)"
    ></note-card-embed> -->
    <!-- <cardify-card
      v-if="!outline && page.flair.enabled.includes('cardify')"
      :page="page"
      :outline="!dashboardView"
      :parentNoteId="note.id"
      :parentPageId="pageId"
      @open="$emit('selectNote', note)"
    >
    </cardify-card> -->
    <embedded-card
      v-if="page"
      ref="embeddedCard"
      :dashboardView="dashboardView"
      :gridView="gridView"
      :userCanEdit="userCanEdit"
      :isPageContent="isPageContent"
      :pageId="note.pageId"
      :nested="nested"
      :nestedLevel="nestedLevel"
      :parentNoteId="note.id"
      :parentPageId="pageId"
      :parentPageNoteLength="parentPageNoteLength"
      :hovering="hovering"
      :focused="focused"
      :showDoc="show"
      :showParent="showParent"
      :dragSelected="dragSelected"
      :editorReady="editorReady"
      :slowLoad="slowLoad"
      :outline="outline"
      :viewed="viewed"
      :renderEditable="renderEditable"
      :delayLoad="delayLoad"
      :dragSelectedFirst="dragSelectedFirst"
      :index="index"
      @mounted="$emit('rendered')"
      @dragstart="handleMouseLeave"
      @deleteNote="removeNotePages({ noteId: note.id, pageId: pageId.replace('root', '') })"
      @moveOrder="$emit('moveOrder', { amount: $event })"
      @moveFirst="$emit('moveOrder', { to: 0 })"
      @moveLast="$emit('moveOrder', { to: 0 })"
      @indentCard="$emit('indentCard', $event)"
      @deIndentCard="$emit('deIndentCard', $event)"
      @testDragSelectStart="testDragSelectStart"
      @setRenderEditable="renderEditable = true"
      @hoverHeader="hovering = $event"
      @blur="focused = false"
      @selectNote="$emit('selectNote', note)"
      @focus="
        focused = true;
        $nextTick(() => {
          setEditingCardId(note.pageId);
          setEditingNoteId(note.id);
        });
      "
      @keyBackspaceEmpty="removeNotePages({ noteId: note.id, pageId: pageId.replace('root', '') })"
      @addNewLineAbove="$emit('addNewLine', { ...$event, order: index, type: 'card' })"
      @addNewLineBelow="$emit('addNewLine', { ...$event, order: index + 1, type: 'card' })"
      @traverseLeaveUp="$emit('traverseBlocks', { toIndex: index - 1, event: $event })"
      @traverseLeaveDown="
        $emit('traverseBlocks', { toIndex: index + 1, event: $event, direction: 'down' })
      "
      @updateSelectedNotes="$emit('updateSelectedNotes', $event)"
      @updateSelectedNotesPage="$emit('updateSelectedNotesPage', $event)"
      @clearDragSelection="$emit('clearDragSelection')"
      @setShow="setShow($event)"
    >
    </embedded-card>
  </v-col>
</template>

<script>
import EmbeddedCard from './EmbeddedCard';
import CardifyCard from './CardifyCard';
// import useFileDragNDrop from '@/views/Context/use/useFileDragNDrop';

import { mapActions } from 'vuex';
import { setTimeout } from 'timers';

import { pagesModule } from '@/store/database/pagesModule';

import { ref, computed, reactive, onMounted } from '@vue/composition-api';
import useContext from '@/views/Context/use/useContext';
import useMultiSelect from '@/views/Context/use/useMultiSelect';
import useClipboard from '@/views/Context/use/useClipboard';
import { fetchMetadataFromUrl } from '@/views/Context/use/useFetchMetadata';
import { removeNotePages } from './use/useDocActions';
export default {
  props: [
    'note',
    'nested',
    'nestedLevel',
    'pageNotes',
    'parentPageNoteLength',
    'pageId',
    'parentPageId',
    'parentNoteId',
    'index',
    'slowLoad',
    'dragSelecting',
    'allowQuoteAttr',
    'participants',
    'docNotes',
    'delayLoad',
    'showParent',
    'docMounted',
    'dashboardView',
    'gridView',
    'pinned',
    'isPageContent',
    'isSelectedPage',
    'outline'
  ],
  setup(props, context) {
    const { setEditingCardId, setEditingNoteId } = useContext();
    // const page = pages[props.pageId];
    // const { addDroppedFilesToPage } = useFileDragNDrop();
    const { startOrder, endOrder } = useMultiSelect();
    const page = computed(() => {
      if (props.note.pageId) {
        const pModule = pagesModule.doc(props.note.pageId);
        if (pModule) {
          return pModule.data;
        } else {
          console.log('this page cant be found', props.note.pageId);
          return false;
        }
      } else {
        return false;
      }
    });

    const inlinePreview = reactive({
      show: false,
      x: 0,
      y: 0,
      resourceId: null
    });

    const handleContextLinkClick = e => {
      e.preventDefault();
      console.log(e);
      console.log(inlinePreview);
      const dataRef = e.srcElement.getAttribute('data-ref');
      if (!dataRef) return;
      const resourceId = dataRef.split('-')[0];
      inlinePreview.resourceId = resourceId;
      inlinePreview.show = true;
      inlinePreview.x = e.offsetX;
      inlinePreview.y = e.offsetY;
    };

    // const setupContextLinks = () => {
    //   //  setup context links
    //   console.log(context);
    //   const links = context.refs.editor.$el.querySelectorAll('.context-link');
    //   console.log('SET LINKS', links);
    //   links.forEach(link => {
    //     //  remove old listener
    //     link.removeEventListener('click', handleContextLinkClick);
    //     //add new listener
    //     link.addEventListener('click', handleContextLinkClick);
    //   });
    // };

    // const dragSelected = ref(false);
    // watch(selectedNoteIds, blocks => {
    //   if (selectedPageId.value !== props.pageId) return;
    //   if (!dragSelected.value && blocks.includes(props.note.id)) {
    //     dragSelected.value = true;
    //   } else if (dragSelected.value && !blocks.includes(props.note.id)) {
    //     dragSelected.value = false;
    //   }
    // });

    const dragSelected = computed(() => {
      const min = Math.min(startOrder.value, endOrder.value);
      const max = Math.max(startOrder.value, endOrder.value);
      return props.isSelectedPage && props.note.order >= min && props.note.order <= max;
    });

    const dragSelectedFirst = computed(() => {
      if (dragSelected.value) {
        const min = Math.min(startOrder.value, endOrder.value);
        return min == props.note.order;
      } else {
        return false;
      }
    });
    // const renderBlock = ref(false);

    // onMounted(() => {
    //   if (props.index > 0) {
    //     requestAnimationFrame(() => {
    //       requestAnimationFrame(() => (renderBlock.value = true));
    //     });
    //     // setTimeout(() => {
    //     //   renderBlock.value = true;
    //     // }, 30 * props.index);
    //   } else {
    //     renderBlock.value = true;
    //   }
    // });

    const { clipboard, resetClipboard } = useClipboard();
    return {
      page,
      inlinePreview,
      // setupContextLinks,
      // addDroppedFilesToPage,
      setEditingCardId,
      setEditingNoteId,
      dragSelected,
      removeNotePages,
      // renderBlock,
      clipboard,
      resetClipboard,
      dragSelectedFirst
    };
  },
  data() {
    return {
      hovering: false,
      hoverHandle: false,
      selected: false,
      noteHover: false,
      editorReady: true,
      dragSelectEvent: false,
      focused: false,
      attrPrompt: { show: false, left: 0, top: 0 },
      embedContextPrompt: { show: false, left: 0, top: 0, search: '' },
      shortcuts: { show: false, left: 0, top: 0 },
      showPreview: false,
      showEmbed: false,
      showAttach: false,
      showSubNotes: false,
      show: this.dashboardView ? this.note.open : this.note.openOutline || false,
      noteBlockMenu: false,
      promptToAdd: { show: false, value: '', adding: false },
      inView: false,
      viewed: false,
      renderEditable: false,
      creatingContext: false,
      userCanEdit: true
    };
  },
  components: {
    EmbeddedCard,
    CardifyCard
  },
  mounted() {
    this.mounted = true;
  },
  destroyed() {
    document.removeEventListener('paste', this.handlePaste);
  },
  watch: {
    focused(val) {
      if (val) {
        //  setup a paste listener on focus
        console.log('add paste listener');
        this.$emit('focused');
        document.addEventListener('paste', this.handlePaste);
      } else {
        //remove paste listener on blur
        console.log('remove paste listener');
        document.removeEventListener('paste', this.handlePaste);
        this.promptToAdd.show = false;
        this.$emit('blurred');
      }
    },
    focusedContainer(val) {
      if (val == this.note.id) {
        //  focus
        console.log('focus');
        this.$vuetify.goTo(this.$el, { container: '#notepage-container' });
      }
    }
  },
  methods: {
    // ...mapMutations('components/magicClipboard', ['resetClipboard']),
    // ...mapActions('resources', ['fetchMetadataFromUrl']),
    log(x) {
      console.log(x);
    },
    handleMouseEnter() {
      // console.log(this.dragSelecting);
      if (this.dragSelecting) {
        this.$emit('selectMouseEnter', { note: this.note, el: this.$el });
      }
    },
    captureWebpage(url) {
      console.log('capture webpage');
      this.promptToAdd.adding = true;
      setTimeout(() => {
        fetchMetadataFromUrl(url)
          .then(sourceData => {
            console.log('created fetched data', sourceData);
            // const resourceData = {
            //   pageId: this.pageId,
            //   order: this.note.order + 1,
            //   html: false,
            //   widgetInfo: {
            //     widgetType: 'resource',
            //     widgetData: {
            //       resourceId: id,
            //       resourceVersion: 1,
            //       resourceNoteIds: []
            //     }
            //   }
            // };
            // this.setResourceViewer({ show: true, resourceId: id, width: 50 });
            this.promptToAdd.adding = false;
            this.promptToAdd.show = false;
            //  update the URL with the title
            if (sourceData.title) {
              const div = document.createElement('div');
              div.innerHTML = this.page.title;
              const a = div.querySelector('a');
              a.innerText = sourceData.title + ' | ' + sourceData.provider;
              this.$refs.embeddedCard.$refs.cardContent.updatePageTitle({
                pageId: this.note.pageId,
                title: div.innerHTML
              });
            }
            //  add image
            let order = 0;
            if (sourceData.image) {
              this.$emit('addNewLine', {
                html: `<a href="${sourceData.image}" target="_blank">${sourceData.image}</a>`,
                order,
                type: 'card',
                pageId: this.page.id
              });
              order++;
            }
            if (sourceData.description) {
              this.$emit('addNewLine', {
                html: sourceData.description,
                order,
                type: 'card',
                pageId: this.page.id
              });
              order++;
            }
            if (sourceData.url) {
              const sourceUrl = `<a href="${sourceData.url}" target="_blank">${sourceData.url}</a>`;
              this.$emit('addNewLine', {
                html: sourceUrl,
                order,
                type: 'card',
                pageId: this.page.id
              });
            }

            // this.$emit('addNoteBlock', resourceData);
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
          });
      }, 2);
    },
    embedContext(contextId) {
      console.log('embed context', this.embedContextPrompt.search, contextId);
      if (!contextId) {
        console.log('no context id, create new?');
        this.createContext();
        return;
      }
      const resourceData = {
        resourceId: contextId,
        resourceNoteIds: [],
        type: 'context'
      };
      this.$emit('convertToEmbeddedContext', resourceData);
    },
    focus() {
      if (this.note.type == 'note') {
        console.log({ ...this.$refs });
        if (!this.renderEditable) {
          this.renderEditable = true;
          this.$nextTick(() => {
            this.$refs.editor.focus();
          });
        } else {
          this.$refs.editor.focus();
        }
      } else if (this.note.type == 'widget') {
        this.$refs.widget.$el.focus();
      } else if (this.note.type == 'card') {
        console.log('focu scard');
        this.$refs.embeddedCard.traverseIn({ prevLeft: 0, direction: 'down' });
      }
    },
    focusNestedNote({ index, noteId }) {
      if (this.$refs.embeddedCard.$refs.cardDoc) {
        this.$refs.embeddedCard.$refs.cardDoc.focusNoteBlock({ index, noteId });
      } else {
        console.log('cant find embedded card. try again.');
        console.log(this.$refs.embeddedCard);
        this.$refs.embeddedCard.showOrHide({});
        this.$nextTick(() => {
          this.$refs.embeddedCard.$refs.cardDoc.focusNoteBlock({ index, noteId });
        });
      }
    },
    setContents(delta) {
      console.log('set contents', delta);
      this.$refs.embeddedCard.$refs.cardContent.$refs.titleEditor.setContents(delta);
    },
    // openResource() {
    //   this.setResourcePanelView(this.widgetResource.id);
    //   this.setShowResourcePanel(true);
    // },
    checkIfUrl(url) {
      //  Check if this is a URL we are pasting
      console.log('check valid url');
      const validURL = function(str) {
        var pattern = new RegExp(
          '^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$',
          'i'
        ); // fragment locator
        return !!pattern.test(str);
      };

      if (validURL(url)) {
        console.log('is valid');
        this.promptToAdd = { show: true, value: url };
      }
    },
    handlePaste(event) {
      console.log('handling paste');
      //  check magic clipboard
      const pasteText = event.clipboardData.getData('text');
      // console.log('event', event);
      // console.log('pasteText', pasteText);
      // console.log(this.clipboard);
      //if image than upload the image
      if (event.clipboardData.files.length > 0) {
        event.preventDefault();
        // console.log('file', event.clipboardData.files[0]);
        // console.log('this.page', this.page);
        // this.addDroppedFilesToPage({
        //   page: this.page.value,
        //   fileList: event.clipboardData.files,
        //   order: this.note.order
        // });
        return;
      }
      //  using contents and parent here for future use when copying resources
      const { text } = this.clipboard;
      console.log(pasteText);
      console.log(text);
      //  quick hack to test inline resource
      if (pasteText.includes('context-link')) {
        console.log('context link!');
        this.$refs.editor.pasteSpecial(pasteText + '&nbsp;');
        event.preventDefault();
        return;
      }
      try {
        const pasteTextClean = pasteText.replace(/\r?\n|\r/g, '~=');
        const textClean = text.replace(/\r?\n|\r/g, '~=');
        console.log(pasteTextClean, textClean);
        //  Check if pasting from magic clip board
        if (pasteTextClean == textClean) {
          event.preventDefault();
          //  Check if pasting into blank note or with content
          // if (this.clipboard.type == 'clip' && !this.isEmpty) {
          //   const { resourceId } = this.clipboard.clipData;
          //   const contextLink = `<a href="#" class="context-link" data-ref="${resourceId}-">${textClean}</span>&nbsp;`;
          //   this.$refs.editor.pasteSpecial(contextLink).then(this.setupContextLinks());
          // } else {
          const noteLength = this.$refs.embeddedCard.$refs.cardContent.pageNoteLength;
          const titleLength = this.$refs.embeddedCard.$refs.cardContent.titleLength;

          this.$emit('pasteBlocks', noteLength == 0 && titleLength == 0);
          // }
          console.log('paste from magic clipboard');
        } else {
          //  we're pasting soething else. clear our coppiedBlocks
          if (this.clipboard.text != null) {
            this.resetClipboard();
            //this.setClipboard({ text: null, blockIds: [] });
          }
          this.checkIfUrl(pasteText);
          return true;
        }
      } catch (e) {
        this.checkIfUrl(pasteText);
        return true;
      }
    },
    handleMouseLeave() {
      if (this.dragSelectEvent && !this.dragSelecting && this.userCanEdit && !this.gridView) {
        console.log('start drag select');
        //  We have dragged outside the block, switch to dragSelect mode
        this.$emit('startDragSelect', this.dragSelectEvent);
        //  focus on this block
        // window.addEventListener('mouseup', this.stopDragSelect);
      }
      // if (this.hovering) {
      //   this.hovering = false;
      // }
    },
    testDragSelectStart(e) {
      console.log('start');
      if (this.userCanEdit) {
        this.dragSelectEvent = e;
        window.addEventListener('mouseup', this.stopDragSelect);
      }
    },
    stopDragSelect() {
      if (this.dragSelectEvent) {
        //  stop drag
        console.log('stop');
        this.dragSelectEvent = false;
        this.$emit('stopDragSelect');
        window.removeEventListener('mouseup', this.stopDragSelecting);
      }
    },
    // async addNewLine(delta) {
    //   const order = this.note.order + 1;
    //   this.$emit('addNewLine', { order, html: '' });
    //   //  update order of all higher up notes
    //   //  new vuex note here, returns id
    //   // const newId = await this.addNoteBlock({
    //   //   html: '',
    //   //   order: newIndex,
    //   //   pageId: this.selectedPageId
    //   // });

    //   // this.$nextTick(() => {
    //   //   if (delta) {
    //   //     this.$emit('setNoteContent', { noteId: newId, delta: delta });
    //   //     //this.$refs['note' + newId][0].setContents(delta);
    //   //   }
    //   //   this.$emit('focusNoteBlock', { noteId: newId });
    //   //   //  this.$refs['note' + newId][0].focus();
    //   // });
    // },
    getContents() {
      return this.$refs.editor ? this.$refs.editor.editor.getContents() : '';
    },
    getText() {
      console.log('getText');
      return this.$refs.editor ? this.$refs.editor.editor.getText() : '';
    },
    promptAttr({ pos, cancel }) {
      console.log(pos, this.$el);
      this.attrPrompt = {
        show: true,
        left: pos[0].left - this.$el.offsetWidth,
        cancel() {
          return cancel();
        }
      };
    },
    promptAddContext({ pos, cancel }) {
      console.log(pos, this.$el);
      this.embedContextPrompt = {
        show: true,
        left: 0,
        cancel() {
          return cancel();
        }
      };
    },
    dragStart(event) {
      const ids = [this.note.id];
      const element = this.$el;
      const shift = {
        x: event.clientX - element.getBoundingClientRect().left,
        y: event.clientY - element.getBoundingClientRect().top
      };
      this.$emit('dragStart', { event, ids, element, shift });
    },
    setShow(v) {
      this.show = v;
      // if (this.note.id.slice(0, 4) != 'root') {
      // const outline = !this.dashboardView;
      // this.setNoteOpen({ noteId: this.note.id, value: v, pageId: this.pageId, outline });
      // }
    }
  }
};
</script>

<style>
.noteBlock {
  margin-bottom: 1px;
  padding-bottom: 4px;
  min-height: 28px;
}

.noteBlock .ql-editor p {
  font-size: 14px;
  margin-bottom: 0px;
}

.section .ql-editor p {
  font-size: 13px;
}

.noteBlock .ql-editor h1 {
  font-size: 1.3em !important;
  /* padding-bottom: 14px; */
  /* margin-top: 20px; */
  font-weight: 500;
  line-height: 1.5em;
}

.noteBlock .ql-editor h2 {
  font-weight: 500;
  font-size: 1.1em;
  margin-top: 0px;
}

.h1-block {
  margin-top: 20px;
  margin-bottom: 2px;
}

.h1-block.first-block {
  margin-top: 0px;
  margin-bottom: 2px;
}

.context-link {
  background: #f3f3f3;
  color: #2196f3 !important;
  border-radius: 20px;
  padding: 0px 5px;
  cursor: pointer;
}
</style>
